import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import BaseBackground from '../../../domain/entities/BaseBackground';

export default function reducer(
  state: {[key: number]: BaseBackground} = {},
  action: AnyAction,
): {[key: number]: BaseBackground} {
  switch (action.type) {
    case Types.IndexBaseBackgroundsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: BaseBackground}, record: BaseBackground) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowBaseBackgroundSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
